interface FormValues {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  message: string;
}

interface OnBlurStatus {
  email: boolean;
  firstName: boolean;
  lastName: boolean;
  phoneNumber: boolean;
  message: boolean;
}

type ValidationErrors = Record<string, string>;

const MIN_EMAIL_LENGTH = 4;
const MIN_NAME_LENGTH = 3;
const MIN_MESSAGE_LENGTH = 10;
const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

const validate = (values: FormValues, onBlurStatus: OnBlurStatus): ValidationErrors => {
  const errors: ValidationErrors = {};
  const { email, firstName, lastName, phoneNumber, message } = values;

  if (onBlurStatus.email && email) {
    if (email.length < MIN_EMAIL_LENGTH || !EMAIL_REGEX.test(email)) {
      errors.email = 'Email address is invalid';
    }
  }

  if (onBlurStatus.email && !email) {
    errors.email = 'Email required';
  }

  if (onBlurStatus.phoneNumber && !phoneNumber) {
    errors.phoneNumber = 'Phone number required';
  }

  if (onBlurStatus.firstName && firstName.trim().length < MIN_NAME_LENGTH) {
    errors.firstName = 'Please enter your first name';
  }

  if (onBlurStatus.lastName && lastName.trim().length < MIN_NAME_LENGTH) {
    errors.lastName = 'Please enter your last name';
  }

  if (onBlurStatus.message && message.length < MIN_MESSAGE_LENGTH) {
    errors.message = 'Please enter a more detailed message';
  }

  return errors;
};

export default validate;
